// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rA8x","title":"styles_title__2U9Yl"};